<template>
  <div class="icons">
    <Icona :icona="icona" v-for="icona in module.icone"/>
  </div>
</template>
<script>
  import ApiService from '@/services/api/ApiService.js';
  import Icona from '@/components/elements/Icona.vue';

  export default {
    name: 'icone',
    props: ['module'],
    data() {
      return {
        icone: [],
      }
    },
    created() {
      console.log(module.icone);
    },
    components: {
      Icona,
    }
  }
</script>
